export const PowerType = {
  Power: {
    value: 'PowerType',
    describe: 'Power',
    image: 'Power.svg',
  },

  PowerSrc: [
    {
      name: 'Generator',
      value: 'Generator.svg',
    },
    {
      name: 'PowerPhase',
      value: 'PowerPhase.svg',
    },
  ],
}
